import { render } from "./VideoCommentText.vue?vue&type=template&id=7c90e050"
import script from "./VideoCommentText.vue?vue&type=script&lang=js"
export * from "./VideoCommentText.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__